import React, { useEffect } from 'react';
import { KeyContainer } from '../../components/developers/KeyContainer';
import { BASE_URL } from '../../../config/environmentConfig';
import { useTranslation } from 'react-i18next';
import { RightSideContainer } from '../../components/developers/RightSideContainer';
import { CSVLinkComponent } from '../../components/developers/CSVLinkComponent';
import { fetchApiKeys } from '../../store/api-client-context';
import { useParams } from 'react-router-dom';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../login/Login';

export interface IApiKeys {
	key: string;
	secret: string;
}

export const ApiKey = (): JSX.Element => {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);
	const mid = user?.['custom:mid'];

	const [apiData, setApiData] = React.useState<IApiKeys[]>([]);
	const [isApiDataLoading, setIsApiDataLoading] = React.useState<boolean>(true);

	const apiKey = apiData?.[0]?.key ? apiData[0].key : '-';
	const apiSecret = apiData?.[0]?.secret ? apiData[0].secret : '-';

	const csvData = [
		[t('API_KEY.API_KEY'), apiKey],
		[t('API_KEY.API_SECRET'), apiSecret]
	];

	const fetchData = async (): Promise<void> => {
		setIsApiDataLoading(true);

		const data = await fetchApiKeys(id);

		setApiData(data);

		setIsApiDataLoading(false);
	};

	useEffect(() => {
		void fetchData();
	}, []);

	return (
		<div className="card mb-5">
			<div className="d-md-flex justify-content-md-between">
				<div className="card-body w-md-50">
					{!id && (
						<KeyContainer
							value={mid}
							title="Mid"
							isTooltipShown
							canCopy
							copyWithText
							additionalCopyClass="ms-3"
						/>
					)}
					<KeyContainer
						value={apiKey}
						title={t('API_KEY.API_KEY')}
						loading={isApiDataLoading}
						isTooltipShown
						canCopy
						copyWithText
						additionalCopyClass="ms-3"
					/>
					<KeyContainer
						value={apiSecret}
						title={t('API_KEY.API_SECRET')}
						isVisible
						loading={isApiDataLoading}
						showPass
						canCopy
						copyWithText
						additionalCopyClass="ms-3"
					/>
					{
						apiKey && apiKey !== '-' && apiSecret && apiSecret !== '-' && (
							<CSVLinkComponent csvData={csvData} filename='apiKeys'/>
						)
					}
				</div>

				<div className="card-body w-md-50">
					<RightSideContainer
						title={t('API_KEY.SECURITY_KEY')}
						text={t('API_KEY.DESCRIPTION')}
						linkText={t('API_KEY.LEARN_MORE')}
						link={BASE_URL.APIKEY_URL}
						isUnderLine
					/>
				</div>

			</div>
		</div>
	);
};
